/**
 * A three-call IndexedDB wrapper for the one thing localStorage cannot hold: the recorded
 * video blob. Everything else about the flow is small enough for localStorage.
 *
 * Every call resolves rather than rejects on a storage failure — losing the cached blob
 * degrades the resume experience, it must never break the flow.
 */

const DB_NAME = "jud-ekyc";
const STORE = "blobs";
export const VIDEO_KEY = "video";

function open() {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      reject(new Error("IndexedDB unavailable"));
      return;
    }
    const request = window.indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) {
        request.result.createObjectStore(STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export function idbPut(key, value) {
  return open()
    .then(
      (db) =>
        new Promise((resolve, reject) => {
          const tx = db.transaction(STORE, "readwrite");
          tx.objectStore(STORE).put(value, key);
          tx.oncomplete = () => {
            db.close();
            resolve(true);
          };
          tx.onerror = () => {
            db.close();
            reject(tx.error);
          };
        })
    )
    .catch(() => false);
}

export function idbGet(key) {
  return open()
    .then(
      (db) =>
        new Promise((resolve) => {
          const tx = db.transaction(STORE, "readonly");
          const request = tx.objectStore(STORE).get(key);
          request.onsuccess = () => resolve(request.result || null);
          request.onerror = () => resolve(null);
          tx.oncomplete = () => db.close();
        })
    )
    .catch(() => null);
}

export function idbDelete(key) {
  return open()
    .then(
      (db) =>
        new Promise((resolve) => {
          const tx = db.transaction(STORE, "readwrite");
          tx.objectStore(STORE).delete(key);
          tx.oncomplete = () => {
            db.close();
            resolve(true);
          };
          tx.onerror = () => {
            db.close();
            resolve(false);
          };
        })
    )
    .catch(() => false);
}
